<template>
  <v-container v-if="groupInfo" fluid class="white px-0 elevation-4">
    <main-app-bar :title="title">
      <template v-slot:buttons>
        <v-btn v-if="$router.currentRoute.name === 'editGroup'" class="mr-4" color="red" dark @click="deleteBtnHandler">Delete</v-btn>
        <v-btn class="mx-4" :to="{name: 'groups'}">Cancel</v-btn>
        <v-btn color="primary" @click="submitMainForm">Save</v-btn>
      </template>
    </main-app-bar>
    <v-form ref="mainForm" v-if="!errorMessage">
      <v-container class="px-5">
        <v-layout row px-4>
          <v-flex xs3 class="d-flex align-center">
            <h3 class="ma-0">Title*</h3>
          </v-flex>
          <v-flex xs6 class="align-center">
            <v-text-field
              v-model="groupInfo.title"
              placeholder="Group Title"
              :rules="groupTitleRules"
              value="true"
              required="false"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <div v-else>
      <h2 class="text-center">{{errorMessage}}</h2>
    </div>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import validationRules from '@/common/validationRules'
  import MainAppBar from '@/components/MainAppBar'

  export default {
    data: () => ({
      groupId: null,
      groupInfo: {
        title: ''
      },
      title: '',
      errorMessage: '',
      groupTitleRules: validationRules.title
    }),
    computed: {
      ...mapGetters(['getGroupById'])
    },
    methods: {
      ...mapActions(['editGroupInfo', 'showAlert', 'deleteGroup']),
      async submitMainForm () {
        if (this.$refs.mainForm.validate()) {
          this.editGroupInfo(this.groupInfo)
        }
      },
      async deleteBtnHandler () {
        if (await this.$root.$confirmDialog.open(this.groupInfo.title)) {
          this.deleteGroup(this.groupInfo.id)
        }
      }
    },
    async mounted () {
      const groupId = +this.$router.currentRoute.params.id
      this.groupId = +this.$router.currentRoute.params.id
      this.groupErrorMessage = ''
      if (groupId) {
        this.groupInfo = this.getGroupById(groupId)
      } else {
        this.title = 'Add Group'
      }
    },
    components: {
      MainAppBar
    }
  }
</script>

<style lang="scss">
  .bordered-table {
    width: 100%;
    max-width: 852px;
    .v-data-table__wrapper {
    }
    table {
      border-collapse: collapse;
      width: 99.5%;
      td {
        padding-left: 10px;
        padding-right: 10px;
        border: 1px solid rgba(0, 0, 0, 0.12);
      }
      thead {
        th {
          border-left: 1px solid #fff;
          padding-left: 10px;
          padding-right: 10px;
        }
        tr {
          th {
            height: 20px;
            padding-top: 0;
            padding-bottom: 0;
          }
          &:first-child {
            th {
              padding: 5px !important;
              height: 20px;
            }
          }
        }
      }
    }
  }
</style>
